import { api } from "./api";
import axios from "axios";


const apiUrl = process.env.VUE_APP_API_URL;

export async function register(payload) {
  const res = await api.post("/auth/register", payload);
  localStorage.setItem("token", res.data.token);
  localStorage.setItem("user", JSON.stringify(res.data.user));
  return res.data;
}

export async function login(payload) {
  const res = await api.post("/auth/login", payload);
  localStorage.setItem("token", res.data.token);
  localStorage.setItem("user", JSON.stringify(res.data.user));
  return res.data;
}

export async function me() {
  const res = await api.get("/auth/me");
  localStorage.setItem("user", JSON.stringify(res.data.user));
  return res.data.user;
}

// ── Profile ───────────────────────────────────
// Full profile for the edit page.
export async function getProfile() {
  const res = await api.get("/auth/profile");
  const user = res.data.user;
  // Keep the cached user (and its completion signal) in sync.
  if (user) localStorage.setItem("user", JSON.stringify(user));
  return user;
}

// Update own profile. Send only changed fields.
export async function updateProfile(payload) {
  const res = await api.put("/auth/profile", payload);
  const user = res.data.user;
  if (user) localStorage.setItem("user", JSON.stringify(user));
  return res.data; // { message, user }
}

// Read the cached user's completion signal (server-driven; never hardcode the list).
export function profileCompletion() {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "null");
    return user?.profile_completion || { complete: true, missing: [], required: [] };
  } catch {
    return { complete: true, missing: [], required: [] };
  }
}

export function getCachedUser() {
  try { return JSON.parse(localStorage.getItem("user") || "null"); }
  catch { return null; }
}

export async function meStats() {
  const token = localStorage.getItem("token");

  const res = await axios.get(`${apiUrl}/auth/me/stats`, {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  });

  return res.data;
}

export async function logout() {
  await api.post("/auth/logout");
  localStorage.removeItem("token");
  localStorage.removeItem("user");
}